import { Component, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { ModalController} from '@ionic/angular';

import { ServiceCategoryService } from '../../../services/service-category.service';
import { UserService } from '../../../services/user.service';
import { ServiceCategory } from '../../../models/service-category/service-category.model';
import { Service } from '../../../models/service/service.model';
import { ServiceDefinition } from '../../../models/service-definition/service-definition.model';
import { Stylist } from '../../../models/stylist/stylist.model';
import { StylistPickerComponent } from '../../../components/stylist-picker/stylist-picker.component';
import { IServiceDefinitionSelectEvent } from '../../../components/service-definition-list/service-definition-list.component';
import { List } from 'immutable';

@Component({
  selector: 'app-sale-service-picker',
  templateUrl: './sale-service-picker.page.html',
  styleUrls: ['./sale-service-picker.page.scss'],
})
export class SaleServicePickerPage implements OnInit {

  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public isLoading: boolean;

  public errorOccurredWhileLoadingProducts: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public serviceCategories: List<ServiceCategory>;

  public readOnlyStylistPicker: boolean;

  @Input() stylist: Stylist;

  constructor (
              //private navParams: NavParams,
              private changeDetectorRef: ChangeDetectorRef,
              private userService: UserService,
              private serviceCategoryService: ServiceCategoryService,
              //private viewController: ViewController
              private modalCtrl: ModalController
              ) {
    this.isLoading = true;
    this.serviceCategories = List([]);
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.onStylistSelect(user.clone());
      if (user.isAdministrator() || user.getViewAllCalendars() === 1) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }
  }

  public ngOnInit () {
    if (!this.stylist) this.stylist = this.userService.getUser();
    this.loadProducts();
  }

  public onTapToReload () {
    this.isLoading = true;
    if (this.errorOccurredWhileLoadingStylistPicker) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.stylistPickerComponent.ngOnInit();
    } else if (this.errorOccurredWhileLoadingProducts) {
      this.errorOccurredWhileLoadingProducts = false;
      this.loadProducts();
    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.stylist = stylist;
  }

  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) { 
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
      this.loadProducts();
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  public loadProducts () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingProducts = false;
    this.serviceCategories = List([]);

    this.serviceCategoryService.getServiceCategories(this.stylist.getID(),this.userService.getSalon().getId())
      .subscribe({next:(categories) => {
        this.isLoading = false;
        this.serviceCategories = categories;
        this.changeDetectorRef.markForCheck();
      },
      error: (e) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingProducts = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  public onDismiss () {
    //this.viewController.dismiss();
    this.modalCtrl.dismiss();   
  }

  public onServiceDefinitionSelect (event: IServiceDefinitionSelectEvent) {
    const serviceDefinition: ServiceDefinition = event.serviceDefinition;
    const service: Service = new Service({
      id: undefined,
      bookingGroupID: undefined,
      stylistID: this.stylist.getID(),
      serviceDefinition: serviceDefinition,
      clientNotes: '',
      stylistNotes: '',
      price: serviceDefinition.getPrice(),
      startDateTime: new Date(),
      durations: {
        startDuration: serviceDefinition.getDuration(),
        processDuration: serviceDefinition.getProcessDuration(),
        finishDuration: serviceDefinition.getFinishDuration()
      },
      lineItemID: undefined,
      clientID:  undefined,
      client: undefined,
      type: 'service',
      name: serviceDefinition.getServiceName(),
      quantity: 1,
      isRefund: 0,
      taxRateType: 0,
      stylist: serviceDefinition.getStylist(),
      isPhantom: true,
      discount: undefined,
      customTaxes: undefined
    });

    //this.viewController.dismiss(service);
    this.modalCtrl.dismiss(service); 
  }


}
